var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5 flex items-center"},[_c('div',{staticClass:"mr-5 ml-5 text-sm font-medium text-neutral-400 sm:ml-0"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"flex-grow h-1 bg-neutral-100"})])}
var staticRenderFns = []

export { render, staticRenderFns }